import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import ListItemText from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemText';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import ListItemSecondaryAction
  from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemSecondaryAction';
import {
  FDLozenge, FDStack,
} from '@facet-wealth/design';
import ListItem from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItem';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import AuthenticationFactorListItemActionPicker from './AuthenticationFactorListItemActionPicker';
import { TextWithTooltip } from './TextWithTooltip';

const useStyles = buildUseStyles('AuthenticationFactorListItem', (theme) => ({
  listItem: {
    paddingRight: theme.spacing(10),
  },
  listItemSecondary: {
    right: 0,
  },
}));


const AuthenticationFactorListItem = ({ authenticationFactorResource }) => {
  const classes = useStyles();

  const TextWithTooltipWrapped = useCallback((props) => <TextWithTooltip resource={authenticationFactorResource} {...props} />, [authenticationFactorResource]);

  return (
    <ListItem className={classes.listItem}>
      <ListItemText
        disableTypography
        primary={
          <FDStack alignItems={'center'} spacing={1}>
            <Typography variant={'h5'} weight={'bold'}>{authenticationFactorResource.selectedOptionPrompt('authenticationType')}</Typography>
            {authenticationFactorResource.attr('isMostSecure') === 'true' ? <FDLozenge color={'success'} label="Our Pick" /> : null}
            {authenticationFactorResource.attr('isComingSoon') === 'true' ? <FDLozenge color={'info'} label="Coming Soon" disabled /> : null}
          </FDStack>
        }
        secondary={
          <Richtext
            Component={TextWithTooltipWrapped}
            richtext
            value={authenticationFactorResource.attr('description')}
          />
        }
      />
      <ListItemSecondaryAction className={classes.listItemSecondary}>
        <AuthenticationFactorListItemActionPicker authenticationFactorResource={authenticationFactorResource} />
      </ListItemSecondaryAction>
    </ListItem>
  );
};

AuthenticationFactorListItem.propTypes = {
  authenticationFactorResource: PropTypes.object.isRequired,
};

export default AuthenticationFactorListItem;
